import { TableCell, TableHead, TableRow, Typography } from '@mui/material'
import shared from '@/components/Settings/settingsShared.module.scss'

export function ActiveSessionsTableHead() {
  return (
    <TableHead>
      <TableRow className={shared.tableHeadRow}>
        <TableCell component="th" scope="col" className={shared.thCellUser}>
          <Typography variant="caption" color="text.secondary" className={shared.thCaption}>Device</Typography>
        </TableCell>
        <TableCell component="th" scope="col" className={shared.thCell}>
          <Typography variant="caption" color="text.secondary" className={shared.thCaption}>Created</Typography>
        </TableCell>
        <TableCell component="th" scope="col" align="right" aria-label="Session actions" className={shared.thCellActions} />
      </TableRow>
    </TableHead>
  )
}
